<template>
  <v-menu
    ref="accountMenu"
    location="bottom"
    role="mainmenu"
    open-on-click
  >
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        :aria-label="$bct('Account menu')"
        class="c-black focus-visible"
        variant="text"
        rounded
      >
        <v-icon
          class="c-black material-icons-round"
          data-cy="click_menu"
          icon="menu"
        />

        <v-badge
          :aria-label="$bct('Badge')"
          :model-value="store.state.newMessage"
          dot
        >
          <v-icon
            v-if="isLoggedIn"
            icon="account_circle"
          />
        </v-badge>
      </v-btn>
    </template>

    <v-list
      color="primary"
      elevation="0"
      border
    >
      <v-list-item
        v-if="isLoggedIn"
        id="dashboard_link"
        :title="$bct('Dashboard')"
        :to="{ name: 'Dashboard' }"
      />

      <v-list-item
        v-if="isLoggedIn"
        :title="$bct('My profile')"
        :to="{ name: 'MemberProfile' }"
        data-cy="my_messages"
      />

      <v-list-item
        v-if="isLoggedIn && store.state.pages.Messaging.enabled"
        :to="{ name: 'MessageIndex' }"
        class="fw-500 fs-16 c-black ta-start"
      >
        <v-list-item-title>
          <v-badge
            :model-value="store.state.newMessage"
            dot
          >
            <span
              class="hover-td-none"
              data-cy="my_messages"
            >
              {{ $bct('My messages') }}
            </span>
          </v-badge>
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="isLoggedIn && store.state.pages.Navigation.settings_url"
        id="settings_link"
        :href="store.state.pages.Navigation.settings_url"
        :title="$bct('Settings')"
      />

      <v-list-item
        v-if="isLoggedIn && store.state.site.features.enable_registration"
        id="subscriptions_link"
        :title="$bct('Email preferences')"
        :to="{ name: 'Subscriptions' }"
      />

      <v-list-item
        v-if="!isLoggedIn"
        id="signup_link"
        :title="$bct('Login')"
        :to="{
          name: 'Signup',
          query: {
            mode: 'login',
          },
        }"
      />

      <v-list-item
        v-if="store.state.pages.Navigation.parent_faq_url"
        id="faq_link"
        :href="store.state.pages.Navigation.parent_faq_url"
        :title="$bct('FAQ')"
        target="_blank"
        tracked
      />

      <v-list-item
        v-if="store.state.pages.Navigation.link_1_name"
        id="link_1_link"
        :href="store.state.pages.Navigation.link_1_url"
        :title="$bct(store.state.pages.Navigation.link_1_name)"
        target="_blank"
      />

      <v-list-item
        v-if="store.state.pages.Navigation.link_2_name"
        id="link_2_link"
        :href="store.state.pages.Navigation.link_2_url"
        :title="$bct(store.state.pages.Navigation.link_2_name)"
        target="_blank"
      />

      <v-list-item
        v-if="store.state.pages.Navigation.menu_link_1_name"
        id="menu_link_1_link"
        :href="store.state.pages.Navigation.menu_link_1_url"
        :title="$bct(store.state.pages.Navigation.menu_link_1_name)"
        target="_blank"
      />

      <v-list-item
        v-if="isAuthenticated && store.state.site.parent_support_email"
        id="menu_report_issue"
        :href="'mailto:' + store.state.site.parent_support_email"
        :title="$bct('Report Issue')"
        target="_blank"
        tracked
      />

      <v-list-item
        id="menu_terms"
        :title="$bct('Terms of Service')"
        href="https://www.getbridgecare.com/terms-of-service"
        target="_blank"
        tracked
      />

      <v-list-item
        :title="$bct('Privacy Policy')"
        href="https://www.getbridgecare.com/privacy-policy"
        target="_blank"
        tracked
      />

      <v-list-item
        v-if="isAuthenticated"
        @click="$emit('sign-out')"
        id="account_menu_signout"
        :title="$bct(isAnonymous ? 'Clear session' : 'Sign out')"
        tracked
      />
    </v-list>
  </v-menu>
</template>

<script setup>
import { useStore } from 'vuex';

defineEmits(['sign-out']);

const store = useStore();
const $bct = inject('translator');

const isAnonymous = computed(() => store.state.is_anonymous);
const isAuthenticated = computed(() => store.state.is_authenticated);
const isLoggedIn = computed(() => isAuthenticated.value && !isAnonymous.value);
</script>
